import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import Header from "./components/Header";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";
import Loader from "./components/Loader";

// Lazy imports
const Home = React.lazy(() => import("./pages/Home/Home"));
const Contributors = React.lazy(() => import("./pages/Contributors/Contributors"));
const Blogs = React.lazy(() => import("./pages/Blogs/Blogs"));
const Contact = React.lazy(() => import("./pages/Contact/Contact"));

function App() {
  return (
    <BrowserRouter>
        <Header />
            <ScrollToTop
                smooth={true}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "dodgerblue",
                    left: "3%",
                    bottom: "3%",
                }}
            />

            <Routes>
                <Route
                    path="/"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <Home />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/contributors"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <Contributors />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/blogs"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <Blogs />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/contact"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <Contact />
                        </React.Suspense>
                    }
                />
                <Route
                    path="*"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <NotFound />
                        </React.Suspense>
                    }
                />
            </Routes>
        <Footer />
    </BrowserRouter>
  );
}

export default App;
